<div 
  [ngClass]="{
    'items-left text-left rtl:items-right rtl:text-right' : alignment === 'left',
    'items-center text-center' : alignment === 'center'
  }"
>

  <!-- Subtitle -->
  <ng-container *ngIf="subtitle; else customSubtitleTemplate">
    <div class="mb-2">
      <h6 
        *ngIf="subtitle"
        class="text-heading-accent"
        [ngClass]="subtitleClasses"
      > 
          {{ subtitle | transloco }}
      </h6>
    </div>
  </ng-container>

  <ng-template #customSubtitleTemplate>
    <ng-content select="[customSubtitle]"></ng-content>
  </ng-template>

  <!-- Title & Button -->
  <div
    [ngClass]="[
      (button?.buttonConfig?.label || customButtonTemplate) && buttonPosition === 'inline' ? 'flex items-center justify-between' : '',
      alignment === 'center' ? 'items-center text-center' : '',
      titleButtonClasses
    ]"
    class="mb-6"
  >
    
    <ng-container *ngIf="title; else customTitleTemplate">
      <h2 *ngIf="title" class="text-heading-main" [ngClass]="titleClasses">
        {{ title | transloco }}
      </h2>
    </ng-container>

    <ng-template #customTitleTemplate>
      <ng-content select="[customTitle]"></ng-content>
    </ng-template>

    <app-button 
      *ngIf="(button?.buttonConfig?.label || customButtonTemplate) && buttonPosition === 'inline'"
      [buttonConfig]="mergedButtonConfig"
      (click)="button?.onClick?.()"
      [route]="button?.route"
      [customTemplate]="customButtonTemplate"
    />
  </div>

  <!-- Description -->
  <p  
    *ngIf="description"
    class="text-body-secondary lg:text-xl text-lg leading-[160%]"
    [ngClass]=descriptionClasses 
  >
    {{ description | transloco }}
  </p>

  <div 
    class="flex mt-6"
    [ngClass]="[
      alignment === 'center' ? 'justify-center' : '',
      alignment === 'left' ? 'justify-start' : '',
      buttonClasses
    ]"
  >
    <app-button 
      *ngIf="(button?.buttonConfig?.label || customButtonTemplate) && buttonPosition === 'below'"
      [buttonConfig]="mergedButtonConfig"
      (click)="button?.onClick?.()"
      [route]="button?.route"
      [customTemplate]="customButtonTemplate"
    />
  </div>
</div>